// extracted by mini-css-extract-plugin
export default {"AttachmentsPage":"YxiIcieGs38ZJlj_5WCv","drawerContent":"qge6UYoH0pzkHW7Aaq4n"};